import PageList from "../abstract/PageList.js";
import GridWrapper from "../../su/GridWrapper.js";

export default class PageSalesUsersList extends PageList {
	constructor() {
		super();
	}

	initList() {
		// h
		let h = this.getAvailableHeight();
		

		//
		this.theGrid = new GridWrapper($(".jsList"));

		let options = {
			noRecordsText: "Nessun utente sales trovato.",
			dataSource: {
				// data: $data.rows,
			},
			sorting: {
				multiple: false,
				allowUnsort: false
			},
			paging: {
				pageSize: 12,
				pageLinksCount: 10
			},
			rowHover: false,
			altRows: false,
			selection: {
				type: "row",
				multiple: false,
				toggle: true,
			},
			columns: [
				{
					field: "LastName",
					title: "Cognome"
				},
				{
					field: "FirstName",
					title: "Nome"
				},
				{
					field: "Email",
					title: "Email"
				},
				{
					field: "SalesContact",
					title: "SalesContact"
				},
				{
					field: "StatusLabel",
					title: "Stato"
				},
				{
					title: "ACTION",
					width: "150px",
					// field: "_idx",
					columnTemplate: this.theGrid.prepareColumnTemplate($("#customActions"), this.initListButton.bind(this))
				}
			],
			scrolling: true,
			resizing: true,
			height: h+"px"
		}

		this.theGrid.create(options, this.data.rows);
		this.theGrid.enableSearch($(".jsListSearch"), {
			or: [
				{ path: "LastName", filter: "contains", value: "" },
				{ path: "FirstName", filter: "contains", value: "" },
				{ path: "Email", filter: "contains", value: "" },
				{ path: "SalesContact", filter: "contains", value: "" },
				{ path: "StatusLabel", filter: "contains", value: "" }
			]
		});
		this.theGrid.init("jsList");
		// var a = StateManager.getViewState("jsList")
		jQuery(window).on("resize.grid", this.onResize.bind(this));

		return;
	}

	getAvailableHeight() {
		let a = jQuery(".js-size");
		let i = 0;
		for (let x = 0; x < a.length; x++) {
			i += jQuery(a[x]).outerHeight();
		}
		i += 50; // padding app container
		i += 78; // search box
		i += 143; // paging
		let h = jQuery(window).height() - i;
		return h;
	}

	onResize(e) {
		//debugger;
		this.theGrid.setHeight(this.getAvailableHeight());
	}

	onAdd() {
		let args = StateManager._splitUrl(document.location.href);
		document.location.href = TheApp.Env.BaseUrlNls + "salesusers/create?_pi=" + encodeURIComponent(args.qPart["_pi"]);
	}

}

